import { showSuccess, showResponseError } from 'utils/messages';

import tmpl from 'templates/webhook_create_modal';
import BaseModal from 'app/views/modals/base_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .confirm_create': 'createWebhook',
  },

  context() {
    return {
      mode: this.collection.apiMode.get('mode'),
    };
  },

  createWebhook(event) {
    event.preventDefault();
    const self = this;
    this.collection.create({
      url: self.$('input#webhook_url').val(),
      mode: self.collection.apiMode.get('mode'),
    }, {
      wait: true,
      success() {
        showSuccess('Webhook successfully created.');
      },
      error(model, response) {
        showResponseError(response);
      },
    }
    );
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/webhook_create_modal.js